const en_master_supplier = {
    add: "add supplier",
    address: "supplier address",
    edit: "edit supplier",
    email: "supplier email",
    fax: "supplier fax",
    name: "supplier name",
    phone: "supplier phone",
    pic: "supplier PIC",
    upload: "upload supplier",

    form: {
        ppn_label: "Enable to use PPN",
        upload_title: "input supplier data",
        coa_debit: "debit COA",
        coa_dp: "Down Payment (DP) COA",
    },

    error: {
        create: "Failed to create supplier.",
        delete: "Failed to delete supplier.",
        edit: "Failed to update supplier.",
    },

    success: {
        create: "Supplier created successfully.",
        delete: "Supplier deleted successfully.",
        edit: "Supplier updated successfully.",
    },
}

export default en_master_supplier;